/**
 * Extracts a bare email address from a string that may contain RFC 2822 format:
 *   "Amaya Carrasco" <amaya@gmail.com>  →  amaya@gmail.com
 *   Amaya <amaya@gmail.com>             →  amaya@gmail.com
 *   amaya@gmail.com                     →  amaya@gmail.com
 *
 * If the input contains multiple comma-separated recipients, only the first is used.
 */
export function extractEmailAddress(input: string): string {
  if (!input) return '';
  const first = (input.split(',')[0] ?? input).trim();
  const extracted = /<([^>]+)>/.exec(first)?.[1];
  if (extracted) return extracted.trim().toLowerCase();
  return first.toLowerCase();
}
